export const FIELDS = {
  ID: 'id',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  PART_ID: 'partId',
  PART_NUMBER: 'partNumber',
  COMPANY_PART_NUMBER: 'companyPartNumber',
  MFG_NAME: 'mfgName',
  CLASS_NAME: 'className',
  CATEGORY_NAME: 'categoryName',
  PACKAGE: 'package',
  ON_HAND: 'onHand',
  DESCRIPTION: 'description',
  PHYS_PKG: 'physPkg',
  PART_COMMENTS: 'partComments',
  PIECE_PER_PKG: 'piecePerPkg',
  OEMEXCESS: 'oemExcess',
  VENDOR_EXCESS: 'vendorExcess',
  IS_IMPORT: 'isImport',
  MANUFACTURER_ID: 'manufacturerId',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  UO_MID: 'uoMId',
  UOM: 'uom',
  PACKAGE_ID: 'packageId',
  CONSIGNMENT: 'consignment',
  ALLOCATED: 'allocated',
  AVAILABLE: 'available',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  ACTIVE: 'active',};